import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

async function fetchJson(url, options = {}) {
  const response = await apiFetch(url, options);
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, `Error ${response.status}`));
  }
  return payload ?? {};
}

export async function fetchDriverBonos() {
  const payload = await fetchJson(`${API_BASE}/driver-bonos`, {
    headers: authHeaders(),
  });
  return Array.isArray(payload?.data) ? payload.data : [];
}

export async function fetchDriverBono(id) {
  return fetchJson(`${API_BASE}/driver-bonos/${encodeURIComponent(id)}`, {
    headers: authHeaders(),
  });
}

export async function createDriverBono(body) {
  return fetchJson(`${API_BASE}/driver-bonos`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
}

export async function updateDriverBono(id, body) {
  return fetchJson(`${API_BASE}/driver-bonos/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
}

export async function deleteDriverBono(id) {
  return fetchJson(`${API_BASE}/driver-bonos/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
}
